import {
	MembershipStatusReason,
	MembershipOrganization,
	EMRAMembershipType,
	SEMPAMembershipType,
	ACEPMembershipType,
	MembershipRate
} from "../enums/xrm.constants";

export class MembershipProfile {
	IsInternational: boolean = false;
	//pga:coding-5865 added new property to check member is from US or Canada
	IsUSOrCanada: boolean = false;
	IsRegYR123: boolean = false;
	membership: CRMMembership;

	allMemberships: CRMMembership[];
	orders: SalesOrder[] = [];
}

export class SalesOrder {
	orderid: any = "";
	ordernumber: any = "";
	createdon: any = "";
	isexpired: any = "";
}

export class CRMMembership {
	MembershipId: string;
	OrderId: string;
	Org: MembershipOrganization = MembershipOrganization.NONE;
	IsOnAutoRenewal: boolean = false;
	IsOnInstallments: boolean = false;

	MemberType: ACEPMembershipType | EMRAMembershipType | SEMPAMembershipType;
	MemberRate: MembershipRate = MembershipRate.None;

	FutureMemberRate: MembershipRate = MembershipRate.None; //will be used for GradResident Project MB 3/19/2024

	CycleStartDate: any;
	ExpirationDate: any;
	PaidThroughDate: any;
	JoinDate: any;
	CancellationDate: any;
	InstallmentOrRenewalDate: any;

	ProgressionSuccessFul: boolean = false;
}
